import { render, staticRenderFns } from "./logisticsEnquiry.vue?vue&type=template&id=c888d0c4&scoped=true&"
import script from "./logisticsEnquiry.vue?vue&type=script&lang=js&"
export * from "./logisticsEnquiry.vue?vue&type=script&lang=js&"
import style0 from "./logisticsEnquiry.vue?vue&type=style&index=0&id=c888d0c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c888d0c4",
  null
  
)

export default component.exports